package com.example.monetix.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Boolean
import kotlin.Long
import kotlin.String

public class PiggyBankQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> all(mapper: (
    id: String,
    name: String,
    accumulatedCents: Long,
    emoji: String,
    colorHex: String,
    imageUri: String?,
    isDeleted: Boolean,
    createdAtEpochMs: Long,
    updatedAtEpochMs: Long,
  ) -> T): Query<T> = Query(-447_619_650, arrayOf("PiggyBankEntity"), driver, "PiggyBank.sq", "all",
      "SELECT PiggyBankEntity.id, PiggyBankEntity.name, PiggyBankEntity.accumulatedCents, PiggyBankEntity.emoji, PiggyBankEntity.colorHex, PiggyBankEntity.imageUri, PiggyBankEntity.isDeleted, PiggyBankEntity.createdAtEpochMs, PiggyBankEntity.updatedAtEpochMs FROM PiggyBankEntity WHERE isDeleted = 0") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getLong(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getBoolean(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!
    )
  }

  public fun all(): Query<PiggyBankEntity> = all { id, name, accumulatedCents, emoji, colorHex,
      imageUri, isDeleted, createdAtEpochMs, updatedAtEpochMs ->
    PiggyBankEntity(
      id,
      name,
      accumulatedCents,
      emoji,
      colorHex,
      imageUri,
      isDeleted,
      createdAtEpochMs,
      updatedAtEpochMs
    )
  }

  public fun <T : Any> getById(id: String, mapper: (
    id: String,
    name: String,
    accumulatedCents: Long,
    emoji: String,
    colorHex: String,
    imageUri: String?,
    isDeleted: Boolean,
    createdAtEpochMs: Long,
    updatedAtEpochMs: Long,
  ) -> T): Query<T> = GetByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getLong(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getBoolean(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!
    )
  }

  public fun getById(id: String): Query<PiggyBankEntity> = getById(id) { id_, name,
      accumulatedCents, emoji, colorHex, imageUri, isDeleted, createdAtEpochMs, updatedAtEpochMs ->
    PiggyBankEntity(
      id_,
      name,
      accumulatedCents,
      emoji,
      colorHex,
      imageUri,
      isDeleted,
      createdAtEpochMs,
      updatedAtEpochMs
    )
  }

  public suspend fun upsert(
    id: String,
    name: String,
    accumulatedCents: Long,
    emoji: String,
    colorHex: String,
    imageUri: String?,
    isDeleted: Boolean,
    createdAtEpochMs: Long,
    updatedAtEpochMs: Long,
  ) {
    driver.execute(1_413_047_282, """
        |INSERT OR REPLACE INTO PiggyBankEntity(
        |    id, name, accumulatedCents, emoji, colorHex, imageUri, isDeleted, createdAtEpochMs, updatedAtEpochMs
        |) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 9) {
          bindString(0, id)
          bindString(1, name)
          bindLong(2, accumulatedCents)
          bindString(3, emoji)
          bindString(4, colorHex)
          bindString(5, imageUri)
          bindBoolean(6, isDeleted)
          bindLong(7, createdAtEpochMs)
          bindLong(8, updatedAtEpochMs)
        }.await()
    notifyQueries(1_413_047_282) { emit ->
      emit("PiggyBankEntity")
    }
  }

  public suspend fun deleteById(updatedAtEpochMs: Long, id: String) {
    driver.execute(-1_545_684_640,
        """UPDATE PiggyBankEntity SET isDeleted = 1, updatedAtEpochMs = ? WHERE id = ?""", 2) {
          bindLong(0, updatedAtEpochMs)
          bindString(1, id)
        }.await()
    notifyQueries(-1_545_684_640) { emit ->
      emit("PiggyBankEntity")
    }
  }

  private inner class GetByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("PiggyBankEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("PiggyBankEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(999_608_805,
        """SELECT PiggyBankEntity.id, PiggyBankEntity.name, PiggyBankEntity.accumulatedCents, PiggyBankEntity.emoji, PiggyBankEntity.colorHex, PiggyBankEntity.imageUri, PiggyBankEntity.isDeleted, PiggyBankEntity.createdAtEpochMs, PiggyBankEntity.updatedAtEpochMs FROM PiggyBankEntity WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "PiggyBank.sq:getById"
  }
}
